import { render, staticRenderFns } from "./formNewEvents.vue?vue&type=template&id=0cbae20b&scoped=true"
import script from "./formNewEvents.vue?vue&type=script&lang=js"
export * from "./formNewEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbae20b",
  null
  
)

export default component.exports